export default __webpack_public_path__ + "static/media/apple-token.29194f1d.png";